var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('md-list',{class:{
            'md-dense': _vm.isDense,
            'md-double-line': _vm.lines == 2,
            'md-triple-line': _vm.lines == 3
        }},[_vm._t("default",_vm._l((_vm.items_),function(item,i){return _c('md-list-item',{key:i,class:{
                    'md-inset': _vm.isPaddItem && !item.icon
                }},[(item.icon)?_c('md-icon',[_vm._v(_vm._s(item.icon))]):_vm._e(),_c('div',{staticClass:"md-list-text-container"},[_c('span',[_vm._v(_vm._s(item.title))]),_c('span',[_vm._v(_vm._s(item.subtitle))])]),(item.action)?_c('md-button',{staticClass:"md-icon-button md-list-action"},[_c('md-icon',{staticClass:"md-primary"},[_vm._v("chat_bubble")])],1):_vm._e(),_c('md-divider',{class:{
                        'md-inset': _vm.isPaddItem && !item.icon
                    }})],1)}))],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b26cce04","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/list/vue/List.vue
// module id = D8uv
// module chunks = 8